import React, { useContext, useState, useEffect } from 'react';
import Navbar from '../components/Navbar/Navbar';
import PageTitle from '../components/PageTitle/PageTitle';
import Footer from '../sections/Footer/Footer';
import BlogCard from '../components/BlogCard/BlogCard';
import { LanguageContext } from '../context/LanguageContext';
import MetaHelmet from '../components/SEO/MetaHelmet';
import BlogsHelmet from '../components/SEO/BlogsHelmet';
import { getBlogPosts, getYoutubeVideoId } from '../services/blogService';
import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner';
import { useSearchParams } from 'react-router-dom';
// ApiTest bileşeni kaldırıldı

const BlogsPage = () => {
    const { t, currentLang } = useContext(LanguageContext);
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchParams] = useSearchParams();
    const categoryParam = searchParams.get('category');
    
    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                setLoading(true);
                const response = await getBlogPosts(currentLang, page, 9);
                
                // API yanıt yapısını kontrol et ve doğru şekilde işle
                if (response && response.data) {
                    // Strapi v4 API yanıt yapısı
                    setBlogs(response.data);
                    if (response.meta && response.meta.pagination) {
                        setTotalPages(response.meta.pagination.pageCount || 1);
                    }
                } else {
                    // Eski API yanıt yapısı veya farklı bir yapı
                    setBlogs(Array.isArray(response) ? response : []);
                    setTotalPages(1);
                }
                
                setLoading(false);
            } catch (error) {
                console.error('Blog yazıları yüklenirken hata oluştu:', error);
                setError('Blog yazıları yüklenirken bir hata oluştu. Lütfen daha sonra tekrar deneyin.');
                setLoading(false);
            }
        };
        
        fetchBlogs();
    }, [currentLang, page]);
    
    const handlePageChange = (newPage) => {
        setPage(newPage);
        window.scrollTo(0, 0);
    };
    
    // Kategori adını belirle
    const categoryName = categoryParam ? blogs.find(blog => {
        // Blog kategorilerini kontrol et
        if (blog.categories && Array.isArray(blog.categories)) {
            return blog.categories.some(cat => cat.slug === categoryParam);
        }
        // Strapi v4 yapısı - attributes.categories.data
        if (blog.attributes?.categories?.data) {
            return blog.attributes.categories.data.some(cat => cat.attributes?.slug === categoryParam || cat.slug === categoryParam);
        }
        return false;
    })?.categories?.find(cat => cat.slug === categoryParam)?.name : null;
    
    return (
        <>
            <MetaHelmet pageName="blogs" />
            <BlogsHelmet blogs={blogs} category={categoryName} />
            <Navbar />
            <PageTitle 
                title={categoryName ? `${categoryName} - ${t('blogs.title')}` : t('blogs.title')} 
                description={t('blogs.description')}
            />
            <section className='pb-70' data-aos="fade-up" data-aos-duration="2000">
                <div className="container">
                    
                    {/* API Test bileşeni kaldırıldı */}
                    {loading ? (
                        <div className="text-center py-5">
                            <LoadingSpinner />
                        </div>
                    ) : error ? (
                        <div className="alert alert-danger text-center" role="alert">
                            {error}
                        </div>
                    ) : (
                        <>
                    <div className="row">
                                {blogs.length > 0 ? (
                                    // Kategori parametresi varsa, sadece o kategoriye ait blogları göster
                                    blogs.filter(blog => {
                                        if (!categoryParam) return true; // Kategori filtresi yoksa tüm blogları göster
                                        
                                        // Blog kategorilerini kontrol et
                                        // 1. Doğrudan categories dizisi
                                        if (blog.categories && Array.isArray(blog.categories)) {
                                            return blog.categories.some(cat => cat.slug === categoryParam);
                                        }
                                        // 2. Strapi v4 yapısı - attributes.categories.data
                                        if (blog.attributes?.categories?.data) {
                                            return blog.attributes.categories.data.some(cat => 
                                                cat.attributes?.slug === categoryParam || cat.slug === categoryParam
                                            );
                                        }
                                        return false;
                                    }).map((blog, index) => {
                                        // Veri yapısını güvenli bir şekilde işleyelim
                                        
                                        // Görsel URL'sini oluşturalım - doğrudan blog nesnesinden
                                        let imageUrl = null;
                                        
                                        // Öncelikle YouTube video URL'si var mı kontrol et
                                        let videoUrl = null;
                                        
                                        // Blog nesnesindeki videoUrl alanını kontrol et - tüm olası yapıları kontrol edelim
                                        if (blog.videoUrl) {
                                            videoUrl = blog.videoUrl;
                                            console.log('Video URL bulundu (doğrudan):', videoUrl);
                                        }
                                        // Strapi v4 yapısı - attributes.videoUrl
                                        else if (blog.attributes && blog.attributes.videoUrl) {
                                            videoUrl = blog.attributes.videoUrl;
                                            console.log('Video URL bulundu (attributes):', videoUrl);
                                        }
                                        // Strapi v4 yapısı - attributes içindeki farklı alanlar
                                        else if (blog.attributes) {
                                            // Tüm attributes içinde video URL'si olabilecek alanları kontrol et
                                            const possibleFields = ['video_url', 'video', 'youtube_url', 'youtube'];
                                            for (const field of possibleFields) {
                                                if (blog.attributes[field]) {
                                                    videoUrl = blog.attributes[field];
                                                    console.log(`Video URL bulundu (${field}):`, videoUrl);
                                                    break;
                                                }
                                            }
                                        }
                                        
                                        // Eğer video URL'si varsa, YouTube thumbnail'ini kullan
                                        if (videoUrl) {
                                            console.log('İşlenecek video URL:', videoUrl);
                                            const videoId = getYoutubeVideoId(videoUrl);
                                            console.log('Çıkarılan video ID:', videoId);
                                            
                                            if (videoId) {
                                                // Doğrudan YouTube thumbnail URL'sini oluştur
                                                imageUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
                                                console.log('Kullanılan YouTube thumbnail:', imageUrl);
                                            } else {
                                                console.log('Video ID çıkarılamadı, URL formatı desteklenmiyor olabilir:', videoUrl);
                                            }
                                        }
                                        // Video URL'si yoksa normal cover image'ı kullan
                                        else {
                                            // En basit ve doğru yaklaşım: cover.url'yi kullan (Cloudinary URL)
                                            if (blog.cover && blog.cover.url) {
                                                imageUrl = blog.cover.url; // Cloudinary URL'si zaten tam URL
                                            }
                                            // Küçük boyutlu görüntü için small formatı kullan
                                            else if (blog.cover && blog.cover.formats && blog.cover.formats.small && blog.cover.formats.small.url) {
                                                imageUrl = blog.cover.formats.small.url;
                                            }
                                            // Thumbnail formatı kullan
                                            else if (blog.cover && blog.cover.formats && blog.cover.formats.thumbnail && blog.cover.formats.thumbnail.url) {
                                                imageUrl = blog.cover.formats.thumbnail.url;
                                            }
                                            // Doğrudan image2 alanını kontrol et
                                            else if (blog.image2) {
                                                imageUrl = blog.image2.startsWith('http') ? blog.image2 : (process.env.REACT_APP_MEDIA_URL || '') + blog.image2;
                                            }
                                            // Doğrudan image alanını kontrol et
                                            else if (blog.image) {
                                                imageUrl = blog.image.startsWith('http') ? blog.image : (process.env.REACT_APP_MEDIA_URL || '') + blog.image;
                                            }
                                            // Strapi v4 yapısı kontrolü (attributes.cover)
                                            else if (blog.attributes && blog.attributes.cover) {
                                                if (blog.attributes.cover.data && blog.attributes.cover.data.attributes) {
                                                    imageUrl = blog.attributes.cover.data.attributes.url;
                                                }
                                            }
                                        }
                                        
                                        // Blog verisini hazırla
                                        const blogData = {
                                            id: blog.id || index,
                                            url: blog.attributes ? blog.attributes.slug : (blog.slug || `blog-${index}`),
                                            img: imageUrl || '/logo192.png', // Varsayılan olarak logo kullan
                                            title: blog.attributes ? blog.attributes.title : (blog.title || 'Blog Başlığı'),
                                            description: blog.attributes ? (blog.attributes.excerpt || blog.attributes.description) : (blog.description || ''),
                                            categories: []
                                        };
                                        
                                        // Kategori bilgilerini güvenli bir şekilde işleyelim
                                        // Strapi v4 yapısı (attributes.categories.data)
                                        if (blog.attributes?.categories?.data && Array.isArray(blog.attributes.categories.data)) {
                                            blogData.categories = blog.attributes.categories.data.map(cat => ({
                                                id: cat.id,
                                                name: cat.attributes?.name || 'Kategori',
                                                slug: cat.attributes?.slug || 'kategori'
                                            }));
                                        }
                                        // Eski yapı (doğrudan categories dizisi)
                                        else if (blog.categories && Array.isArray(blog.categories)) {
                                            blogData.categories = blog.categories.map(cat => ({
                                                id: cat.id,
                                                name: cat.name || 'Kategori',
                                                slug: cat.slug || 'kategori'
                                            }));
                                        }
                                        
                                        return (
                                            <BlogCard
                                                key={blog.id}
                                                blog={{
                                                    ...blog,
                                                    url: blog.slug,
                                                    img: imageUrl, // YouTube thumbnail veya normal görüntü URL'sini aktar
                                                    categories: blog.categories?.data || []
                                                }}
                                                index={index}
                                            />
                                        );
                                    })
                                ) : (
                                    <div className="col-12 text-center py-5">
                                        <h3>{t('blogs.noBlogsFound')}</h3>
                                    </div>
                                )}
                            </div>
                            
                            {totalPages > 1 && (
                                <div className="row mt-4">
                                    <div className="col-12">
                                        <nav aria-label="Blog pagination">
                                            <ul className="pagination justify-content-center">
                                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                                    <button 
                                                        className="page-link" 
                                                        onClick={() => handlePageChange(page - 1)}
                                                        disabled={page === 1}
                                                    >
                                                        {t('pagination.previous')}
                                                    </button>
                                                </li>
                                                {[...Array(totalPages).keys()].map(i => (
                                                    <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                                        <button 
                                                            className="page-link" 
                                                            onClick={() => handlePageChange(i + 1)}
                                                        >
                                                            {i + 1}
                                                        </button>
                                                    </li>
                                                ))}
                                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                                    <button 
                                                        className="page-link" 
                                                        onClick={() => handlePageChange(page + 1)}
                                                        disabled={page === totalPages}
                                                    >
                                                        {t('pagination.next')}
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                    </div>
                            )}
                        </>
                    )}
                </div>
            </section>
            <Footer />
        </>
    );
};

export default BlogsPage;